import React from "react"
import autobind from "class-autobind"
import { IPosition, IPayType, IScheduleShift, IPayClass, IPunchPositionDocument, IUIUser, IDate, IPunchShortDocument } from "../../models"
import AccountStore from "../../stores/AccountStore"
import strings from "../../localization/strings"
import PositionSelector from "../position/PositionSelector"
import PayClassSelector from "../position/pay_class/PayClassSelector"
import { SelectField, MenuItem } from "material-ui"
import * as punchActions from "../../actions/PunchActions"
import * as payGroupAndTypeHelper from "../../helpers/payGroupAndTypeHelper"
import _ from "lodash"
import { green500 } from "material-ui/styles/colors"
import * as positionHelper from "../../helpers/positionHelper"

interface IProps {
    readonly: boolean
    employee: IUIUser
    hierarchyId: string
    shiftId: string
    jobId: string
    phaseId: string
    selectedPositionId: string
    selectedPayClassId: string
    selectedPayTypeId: string
    keepPropsPayClassId_PayTypeId: boolean
    hierarchyLevelIntentionalChanged: boolean
    handleSelectPosition(position: IPosition, errorSelectedPosition: string): void
    handleSelectPayClass(payClassId: string): void
    handleSelectPayType(payTypeId: string, errorPayTypeId: string): void
    handleLoadingPositions(loading: boolean): void

    // we need it to check Position's Start/End dates
    date: IDate

    // if enable payclass, when edit punch or punch out
    // we need to use the stored punch position insted of getting position
    referencePunchPositionDocumentId: string

    //GlobalPunch Add/Edit
    isGlobalPunch?: boolean
    isGlobalPunchEdit?: boolean
    globalPunchEmployees?: IUIUser[]
    commonGlobalPunchData?: IPunchShortDocument

    //Employee->Timecard->PunchDrawerTable
    isPunchListTable?: boolean
    useEditablePunchTableDataStore?: boolean //if isPunchListTable is true, dont need to set this value
    tableColWidth?: number
    tableColsMarginWidth?: number

    //by some validation on Expense etc
    errorSelectedPayTypeId?: string
    //in expense case, we are not store full position document on db and override PayRate, BillRate, Burden and PayTypeId
    //in the edit Expense case, we should show Position with expense PayRate, BillRate, Burden and PayTypeId
    overridePositionInfo?: IPosition

    //we hide payinfo for AmountExpense
    hidePayInfo?: boolean

    hideIcons?: boolean
    payTypeLabel?: string
    readonlyPayClassSelector?: boolean
}
interface IState {
    loadingPositions: boolean
    positions: IPosition[]
    selectedPosition: IPosition
    errorSelectedPosition: string
    selectedPayClassId: string
    selectedPayTypeId: string
    errorSelectedPayTypeId: string
    availablePayTypes: IPayType[]
    availablePayClasses: IPayClass[]
}

export default class Position_PayType_PayClass_Selector extends React.Component<IProps, IState> {
    private linkedPayTypesInPayGroup: IPayType[] = []
    private defaultPayTypeInPayGroup: IPayType = null
    private shift: IScheduleShift = null
    private addGlobalPayTypeId
    private addGlobalPayType
    private punchPositionDocument: IPunchPositionDocument = null
    constructor(props: IProps) {
        super(props)
        this.state = {
            loadingPositions: false,
            positions: [],
            selectedPosition: null,
            errorSelectedPosition: null,
            selectedPayClassId: props.selectedPayClassId,
            selectedPayTypeId: props.selectedPayTypeId,
            errorSelectedPayTypeId: null,
            availablePayTypes: [],
            availablePayClasses: []
        }
        autobind(this)
        if (props.isGlobalPunch) {
            this.addGlobalPayTypeId = props.isGlobalPunchEdit ? AccountStore.DiffPayTypeId : AccountStore.EmptyPayTypeId
            this.addGlobalPayType = props.isGlobalPunchEdit ? AccountStore.DiffPayType : AccountStore.EmptyPayType
        }
        this.getLinkedPayTypes_DefaultPayType(props.employee)
    }

    componentDidMount() {
        this.props.shiftId ?
            this.getShift(this.getPositions(this.props, true)) :
            this.getPositions(this.props, true)
    }

    componentWillReceiveProps(nextProps: IProps) {
        const previousEmployeeId = this.props.employee ? this.props.employee.Id : null
        const nextEmployeeId = nextProps.employee ? nextProps.employee.Id : null
        previousEmployeeId !== nextEmployeeId &&
            this.getLinkedPayTypes_DefaultPayType(nextProps.employee)
        if (
            previousEmployeeId !== nextEmployeeId ||
            this.props.hierarchyId !== nextProps.hierarchyId ||
            this.props.jobId !== nextProps.jobId ||
            this.props.phaseId !== nextProps.phaseId ||
            this.props.shiftId !== nextProps.shiftId
        ) {
            this.getPositions(nextProps, !nextProps.hierarchyLevelIntentionalChanged)
        }

        this.props.date !== nextProps.date &&
            this.checkPositionDate(this.state.selectedPosition, nextProps)
    }

    checkPositionDate(selectedPosition: IPosition, props: IProps) {
        const isValid = props.isGlobalPunch ?
            props.isGlobalPunchEdit ?
                positionHelper.checkPositionDateForGlobalEditPunches(selectedPosition, props.commonGlobalPunchData, props.globalPunchEmployees) :
                positionHelper.checkPositionDateForGlobalAddPunches(selectedPosition, props.date, props.globalPunchEmployees) :
            positionHelper.checkPositionDate(selectedPosition, props.date, props.employee ? props.employee.PayrollPayGroupId : null)

        const errorSelectedPosition = !isValid ?
            positionHelper.getPositionDateErrorStr(selectedPosition) :
            ""

        this.setState({ errorSelectedPosition })
        this.props.handleSelectPosition(selectedPosition, errorSelectedPosition)
        return errorSelectedPosition
    }

    getLinkedPayTypes_DefaultPayType(employee: IUIUser) {
        if (this.props.isGlobalPunch) {
            const payGroupIds = this.props.globalPunchEmployees.map(employee => payGroupAndTypeHelper.getPayGroupIdByPayrollPayGroupData({ PayrollHierarchyItemId: employee.PayrollHierarchyItemId, PayrollPayGroupId: employee.PayrollPayGroupId }))
            const uniquePayGroupIds = payGroupIds.filter((c, index) => payGroupIds.indexOf(c) === index)
            if (uniquePayGroupIds.length === 1) {
                this.defaultPayTypeInPayGroup = payGroupAndTypeHelper.getDefaultPayType(uniquePayGroupIds[0])
                this.linkedPayTypesInPayGroup = payGroupAndTypeHelper.getLinkedPayTypes(uniquePayGroupIds[0])
            }
            else {
                const linkedPayTypesInPayGroups = uniquePayGroupIds.map(payGroupId => payGroupAndTypeHelper.getLinkedPayTypes(payGroupId))
                const payTypes: IPayType[] = []
                linkedPayTypesInPayGroups.forEach(i => i.forEach(e =>
                    !payTypes.find(k => k.Id === e.Id) &&
                    payTypes.push(e)
                ))
                this.linkedPayTypesInPayGroup = payTypes
            }
            this.linkedPayTypesInPayGroup.push(this.addGlobalPayType)
            this.defaultPayTypeInPayGroup = this.defaultPayTypeInPayGroup ? this.defaultPayTypeInPayGroup : this.addGlobalPayType
        }
        else {
            if (!employee) return
            const payGroupId = payGroupAndTypeHelper.getPayGroupIdByPayrollPayGroupData({ PayrollHierarchyItemId: employee.PayrollHierarchyItemId, PayrollPayGroupId: employee.PayrollPayGroupId })
            this.defaultPayTypeInPayGroup = payGroupAndTypeHelper.getDefaultPayType(payGroupId)
            this.linkedPayTypesInPayGroup = payGroupAndTypeHelper.getLinkedPayTypes(payGroupId)
        }
    }

    getShift(cb = null) {
        punchActions.getShift(this.props.shiftId, this.props.isPunchListTable || this.props.useEditablePunchTableDataStore).then(shift => {
            this.shift = shift
            cb && cb()
        })
    }

    getPositions(props: IProps, firstLoading: boolean) {
        this.setState({ loadingPositions: true }, async () => {
            this.props.handleLoadingPositions(true)

            const punchPositionDocumentId = this.punchPositionDocument ? this.punchPositionDocument.Id : null
            if (AccountStore.getPayClassEnabled() && this.props.referencePunchPositionDocumentId && punchPositionDocumentId !== this.props.referencePunchPositionDocumentId) {
                this.punchPositionDocument = await punchActions.getPunchPosition(this.props.referencePunchPositionDocumentId, this.props.isPunchListTable || this.props.useEditablePunchTableDataStore)
            }

            const propsEmployeeId = props.isGlobalPunch ?
                props.globalPunchEmployees && props.globalPunchEmployees.length === 1 ?
                    props.globalPunchEmployees[0].Id :
                    null :
                props.employee ?
                    props.employee.Id :
                    null

            const thisPropsEmployeeId = this.props.isGlobalPunch ?
                this.props.globalPunchEmployees && this.props.globalPunchEmployees.length === 1 ?
                    this.props.globalPunchEmployees[0].Id :
                    null :
                this.props.employee ?
                    this.props.employee.Id :
                    null

            const result = await punchActions.getPositions(propsEmployeeId, props.hierarchyId, props.shiftId, props.jobId, props.phaseId, this.props.isPunchListTable || this.props.useEditablePunchTableDataStore)
            if (result.userId !== thisPropsEmployeeId ||
                result.hierarchyId !== this.props.hierarchyId ||
                result.shiftId !== this.props.shiftId ||
                result.jobId !== this.props.jobId ||
                result.phaseId !== this.props.phaseId
            )
                return

            const positions = result.positions

            if (this.punchPositionDocument && this.punchPositionDocument.Position) {
                const indexOf = positions.findIndex(i => i.Id === this.punchPositionDocument.Position.Id)
                const basePositionIndexOf = positions.findIndex(i => i.BasePositionId === this.punchPositionDocument.Position.BasePositionId)
                if (indexOf > -1) {
                    positions[indexOf] = this.punchPositionDocument.Position
                }
                else if (basePositionIndexOf > -1) {
                    positions[basePositionIndexOf] = this.punchPositionDocument.Position
                }
                else {
                    positions.push(this.punchPositionDocument.Position)
                }
            }

            if (firstLoading && this.props.overridePositionInfo) {
                const indexOf = positions.findIndex(i => i.Id === this.props.overridePositionInfo.Id)
                if (indexOf > -1) {
                    const overridePosition = positions[indexOf]
                    overridePosition.PayTypeId = this.props.overridePositionInfo.PayTypeId
                    const indexOfPayClasses = overridePosition.AvailablePayClasses.findIndex(i => i.Id === this.props.overridePositionInfo.DefaultPayClass.Id)
                    if (indexOfPayClasses > -1) {
                        const overridePayClass = overridePosition.AvailablePayClasses[indexOfPayClasses]
                        overridePayClass.PayTypeId = this.props.overridePositionInfo.PayTypeId
                        overridePayClass.PayInfo.PayRate = this.props.overridePositionInfo.DefaultPayClass.PayInfo.PayRate
                        overridePayClass.PayInfo.BillRate = this.props.overridePositionInfo.DefaultPayClass.PayInfo.BillRate
                        overridePayClass.PayInfo.Burden = this.props.overridePositionInfo.DefaultPayClass.PayInfo.Burden
                        overridePosition.AvailablePayClasses[indexOfPayClasses] = overridePayClass
                        if (overridePosition.DefaultPayClass.Id === overridePayClass.Id) {
                            overridePosition.DefaultPayClass = overridePayClass
                        }
                    }
                    positions[indexOf] = overridePosition
                }
            }

            !props.hierarchyLevelIntentionalChanged && props.selectedPositionId === AccountStore.DiffPositionId &&
                positions.unshift(AccountStore.DiffPosition)
            const position = positions.find(i => i && i.Id === props.selectedPositionId)
            const selectedPosition = position ? position : null
            this.setState({
                loadingPositions: false,
                positions,
                selectedPosition,
                availablePayClasses: selectedPosition && selectedPosition.DefaultPayClass ? selectedPosition.AvailablePayClasses : []
            }, () => {
                this.props.handleLoadingPositions(false)
                this.handleSelectPosition(selectedPosition, !firstLoading, false)
            })
        })
    }

    handleSelectPosition(selectedPosition: IPosition, useDefaultPayType: boolean, byPositionSelector: boolean) {
        const defaultPayClass: IPayClass = selectedPosition && selectedPosition.DefaultPayClass ? selectedPosition.DefaultPayClass : null

        let defaultPayTypeId: string = null
        let availablePayTypeIds: string[] = []

        if (!defaultPayClass || !this.state.selectedPayClassId) {
            if (selectedPosition && this.shift) {
                const shiftPayTypeId = this.shift.PayTypeId ? this.shift.PayTypeId : selectedPosition.PayTypeId
                if (shiftPayTypeId) {
                    defaultPayTypeId = shiftPayTypeId
                }
            }

            if (selectedPosition && selectedPosition.PayTypeId) {
                defaultPayTypeId = selectedPosition.PayTypeId
            }

            if (!defaultPayTypeId) {
                defaultPayTypeId = this.props.isGlobalPunch ?
                    this.addGlobalPayTypeId :
                    this.defaultPayTypeInPayGroup ? this.defaultPayTypeInPayGroup.Id : null
            }

            if (!availablePayTypeIds.length) {
                availablePayTypeIds = this.linkedPayTypesInPayGroup.map(i => i.Id)
            }
        }
        else {
            const selectedPayClass = selectedPosition && selectedPosition.AvailablePayClasses &&
                selectedPosition.AvailablePayClasses.find(i => i.Id === this.state.selectedPayClassId)
            availablePayTypeIds = selectedPayClass ? [selectedPayClass.PayTypeId] : [defaultPayClass.PayTypeId]
            defaultPayTypeId = defaultPayClass.PayTypeId
        }

        const selectedPayTypeId = byPositionSelector ?
            defaultPayTypeId :
            (this.props.keepPropsPayClassId_PayTypeId || !useDefaultPayType) ?
                this.state.selectedPayTypeId ?
                    availablePayTypeIds.includes(this.state.selectedPayTypeId) ?
                        this.state.selectedPayTypeId :
                        AccountStore.InvalidPayTypeId :
                    defaultPayTypeId :
                defaultPayTypeId
        const selectedPayClassId =
            byPositionSelector ?
                defaultPayClass ?
                    defaultPayClass.Id :
                    null :
                selectedPosition && selectedPosition.AvailablePayClasses && selectedPosition.AvailablePayClasses.find(i => i.Id === this.state.selectedPayClassId) ?
                    this.state.selectedPayClassId :
                    null

        this.setState({
            selectedPayClassId,
            selectedPayTypeId,
            availablePayTypes: availablePayTypeIds.map(i => i === this.addGlobalPayTypeId ? this.addGlobalPayType : AccountStore.getCurrentAccount().PayTypes.find(e => e.Id === i)),
        })

        const errorSelectedPosition = this.checkPositionDate(selectedPosition, this.props)
        this.props.handleSelectPosition(selectedPosition, errorSelectedPosition)
        this.props.handleSelectPayClass(selectedPayClassId)
        this.handleSelectPayType(selectedPayTypeId)
    }

    handleSelectPayType(selectedPayTypeId: string) {
        const errorSelectedPayTypeId = this.linkedPayTypesInPayGroup.map(i => i.Id).includes(selectedPayTypeId) ? null : strings.Pay_Type_is_not_valid
        this.setState({ errorSelectedPayTypeId })
        this.props.handleSelectPayType(selectedPayTypeId, errorSelectedPayTypeId)
    }

    render() {
        if (!this.props.isGlobalPunch && !this.props.employee) return null
        return (
            <div style={{ display: this.props.isPunchListTable && "flex", justifyContent: "space-between" }}>
                {((this.state.positions && this.state.positions.length > 0) || this.props.isPunchListTable) &&
                    <div style={{ display: "flex", width: this.props.isPunchListTable && this.props.tableColWidth, marginLeft: this.props.tableColsMarginWidth, marginRight: this.props.tableColsMarginWidth }}>
                        {!this.props.hideIcons &&
                            <div style={{ float: "left", paddingTop: 40 }}>
                                <i className="fa fa-user" style={{ marginRight: 10 }} />
                            </div>
                        }
                        <PositionSelector
                            disabled={this.props.readonly}
                            label={this.props.isPunchListTable ? "" :
                                positionHelper.checkPositionFieldAvailable('singular') ?
                                    AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel :
                                    strings.Position
                            }
                            hidePayInfo={this.props.isPunchListTable === true}
                            style={{ width: this.props.isPunchListTable ? this.props.tableColWidth : 256, height: this.props.isPunchListTable ? 40 : 72 }}
                            iconStyle={{ width: this.props.isPunchListTable ? 34 : 48, top: this.props.isPunchListTable ? -4 : 8 }}
                            labelStyle={{ fontSize: this.props.isPunchListTable ? 12 : 16, height: this.props.isPunchListTable ? 25 : 56, lineHeight: this.props.isPunchListTable ? "25px" : "56px", top: this.props.isPunchListTable ? 5 : 6, paddingRight: this.props.isPunchListTable ? 18 : 56 }}
                            positionId={this.state.selectedPosition ? this.state.selectedPosition.Id : null}
                            positions={this.state.positions}
                            onSave={positionId => {
                                const position = this.state.positions.find(i => i && i.Id === positionId)
                                const selectedPosition = position ? position : null
                                this.setState({
                                    selectedPosition,
                                    availablePayClasses: selectedPosition && selectedPosition.DefaultPayClass ? selectedPosition.AvailablePayClasses : []
                                })
                                this.handleSelectPosition(selectedPosition, true, true)
                            }}
                            errorLabelFontSize={12}
                            errorText={this.state.errorSelectedPosition}
                        />
                    </div>
                }
                {AccountStore.getPayClassEnabled() &&
                    <div style={{ width: this.props.isPunchListTable && this.props.tableColWidth, marginLeft: this.props.tableColsMarginWidth, marginRight: this.props.tableColsMarginWidth }}>
                        {AccountStore.getTimecardEnabled() && this.state.availablePayClasses && this.state.availablePayClasses.length > 0 &&
                            <div style={{ display: "flex" }}>
                                {!this.props.hideIcons &&
                                    <i className="fa fa-tag" style={{ marginRight: 10, marginTop: 40 }} />
                                }
                                <PayClassSelector
                                    keepPropsPayClassId={this.props.keepPropsPayClassId_PayTypeId}
                                    readonly={this.props.readonly || this.props.readonlyPayClassSelector}
                                    hidePayInfo={this.props.isPunchListTable === true || this.props.hidePayInfo}
                                    style={{ width: this.props.isPunchListTable ? this.props.tableColWidth - 15 : 256, height: this.props.isPunchListTable ? 40 : 72 }}
                                    iconStyle={{ width: this.props.isPunchListTable ? 34 : 48, top: this.props.isPunchListTable ? -4 : 8 }}
                                    labelStyle={{ fontSize: this.props.isPunchListTable ? 12 : 16, height: this.props.isPunchListTable ? 25 : 56, lineHeight: this.props.isPunchListTable ? "25px" : "56px", top: this.props.isPunchListTable ? 5 : 6, paddingRight: this.props.isPunchListTable ? 18 : 56 }}
                                    defaultPayClass={this.state.selectedPosition.DefaultPayClass}
                                    availablePayClasses={this.state.selectedPosition.AvailablePayClasses}
                                    selectedPayClassId={this.state.selectedPayClassId}
                                    availablePayTypeIds={this.linkedPayTypesInPayGroup ? this.linkedPayTypesInPayGroup.map(i => i.Id) : null}
                                    handleChange={(availablePayClasses, defaultPayClass, selectedPayClassId) => {
                                        const selectedPosition = this.state.selectedPosition
                                        selectedPosition.DefaultPayClass = defaultPayClass
                                        selectedPosition.AvailablePayClasses = availablePayClasses
                                        const selectedPayClass = availablePayClasses.find(i => i.Id === selectedPayClassId)
                                        const selectedPayTypeId = selectedPayClass ? selectedPayClass.PayTypeId : this.state.selectedPayTypeId
                                        this.setState({
                                            availablePayClasses,
                                            selectedPayClassId,
                                            selectedPosition,
                                            selectedPayTypeId,
                                            availablePayTypes: [AccountStore.getCurrentAccount().PayTypes.find(e => e.Id === selectedPayTypeId)]
                                        })

                                        const errorSelectedPosition = this.checkPositionDate(selectedPosition, this.props)
                                        this.props.handleSelectPosition(selectedPosition, errorSelectedPosition)
                                        this.props.handleSelectPayClass(selectedPayClassId)
                                        this.handleSelectPayType(selectedPayTypeId)
                                    }}
                                    isPunchListTable={this.props.isPunchListTable}
                                />
                            </div>
                        }
                    </div>
                }
                <div style={{ width: this.props.isPunchListTable && this.props.tableColWidth, marginLeft: this.props.tableColsMarginWidth, marginRight: this.props.tableColsMarginWidth }}>
                    {AccountStore.getTimecardEnabled() && this.state.availablePayTypes && this.state.availablePayTypes.length > 0 &&
                        <div style={{ display: "flex" }}>
                            {!this.props.hideIcons &&
                                <i className="fa fa-tag" style={{ marginRight: 10, marginTop: 40 }} />
                            }
                            <SelectField
                                data-intercom-target={"Select-PayType"}
                                autoWidth
                                floatingLabelText={this.props.payTypeLabel ? this.props.payTypeLabel : this.props.isPunchListTable ? "" : strings.Default_Pay_Type}
                                style={{ width: this.props.isPunchListTable ? this.props.tableColWidth : 256, height: this.props.isPunchListTable ? 40 : 72 }}
                                iconStyle={{ width: this.props.isPunchListTable ? 34 : 48, top: this.props.isPunchListTable ? -4 : 8 }}
                                labelStyle={{ color: this.state.selectedPayTypeId === AccountStore.DiffPayTypeId && green500, fontSize: this.props.isPunchListTable ? 12 : 16, height: this.props.isPunchListTable ? 25 : 56, lineHeight: this.props.isPunchListTable ? "25px" : "56px", top: this.props.isPunchListTable ? 5 : 6, paddingRight: this.props.isPunchListTable ? 18 : 56 }}
                                value={this.state.selectedPayTypeId}
                                onChange={(object, key, payload) => {
                                    this.setState({ selectedPayTypeId: payload })
                                    this.handleSelectPayType(payload)
                                }}
                                disabled={this.state.availablePayTypes.length < 2 || this.props.readonly}
                                errorText={this.state.errorSelectedPayTypeId || this.props.errorSelectedPayTypeId}
                                errorStyle={{ position: "absolute", top: 70 }}
                            >
                                {this.state.availablePayTypes.sort((a, b) => {
                                    if (a == null || b == null) return -1
                                    if (a.Id === AccountStore.DiffPayTypeId) return -1
                                    if (b.Id === AccountStore.DiffPayTypeId) return 1
                                    if (a.Name === b.Name) return 0
                                    if (a.Name < b.Name) return -1
                                    if (a.Name > b.Name) return 1
                                }).map((payType, index) =>
                                    <MenuItem value={payType.Id} primaryText={payType.Name} key={index} style={{ color: payType.Id === AccountStore.DiffPayTypeId && green500 }} />
                                )}
                                {this.state.selectedPayTypeId &&
                                    this.state.selectedPayTypeId !== AccountStore.InvalidPayTypeId &&
                                    this.state.selectedPayTypeId !== AccountStore.DiffPayTypeId &&
                                    this.state.selectedPayTypeId !== AccountStore.EmptyPayTypeId &&
                                    !this.state.availablePayTypes.find(i => i.Id === this.state.selectedPayTypeId) &&
                                    <MenuItem
                                        disabled
                                        value={AccountStore.getCurrentAccount().PayTypes.find(i => i.Id === this.state.selectedPayTypeId).Id}
                                        primaryText={AccountStore.getCurrentAccount().PayTypes.find(i => i.Id === this.state.selectedPayTypeId).Name}
                                    />
                                }
                                {this.state.selectedPayTypeId &&
                                    this.state.selectedPayTypeId === AccountStore.InvalidPayTypeId &&
                                    <MenuItem
                                        disabled
                                        value={AccountStore.InvalidPayTypeId}
                                        primaryText={strings.invalid}
                                    />
                                }
                            </SelectField>
                        </div>
                    }
                </div>
            </div>
        )
    }
}